<template>
    <div class="infoList">
        <div class="infoList-title"><span>{{ data.listData.title }}</span> <span>更多<DoubleRightOutlined /></span></div>
        <div class="infoList-card">
            <div class="infoList-card-line" v-for="(item, i) in data.listData.list" :key="i">
                <div></div>
                <div class="info-card-line-text">
                    <p @click="handleClick(item.id, data.listData.title, data.listData.secId)">{{ item.title }}</p><p>{{ item.date }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { reactive, onMounted } from 'vue'
import DoubleRightOutlined from '@ant-design/icons-vue/lib/icons/DoubleRightOutlined'
export default {
    name: "infoCard",
    props: {
        listData: Object
    },
    setup(props, { emit }) {
        const data = reactive({
            listData: {
                listData: {
                    title: ''
                }
            }
        })
        const handleClick = (id, title, secId) => {
            emit('cardEvent', {id: id,title: title, secId: secId})
        }
        onMounted(() => {
            data.listData = props.listData
        })
        return {
            data,
            handleClick
        }
    },
    components: {
        DoubleRightOutlined
    }
}
</script>

<style scoped lang="stylus">
    .infoList {
        width 100%
        background-color #FFF
        padding 10px 25px
        margin 10px 0
        .infoList-title {
            width 100%
            height 18px
            line-height 18px
            border-left 3px solid #44A73D
            padding-left 5px
            color #44A73D
            font-size 14px
            font-weight bolder
            display flex
            justify-content space-between
            margin-bottom 10px
        }
        .infoList-title span {
            display inline-block
        }
        .infoList-title span:last-child {
            color #44A73D
            position relative
            right 0
            font-size 12px
        }
        .infoList-card {
            width 100%
            //height 80px
            padding 5px 10px
            box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16)
            .infoList-card-line {
                width 100%
                display flex
                flex-wrap nowrap
                margin 10px 0
                .info-card-line-text {
                    width calc(100% - 20px)
                    height 20px
                    display flex
                    line-height 20px
                    flex-wrap nowrap
                    justify-content space-between
                    border-bottom 1px dashed #707070
                }
                .info-card-line-text p:first-child {
                    width 70%
                    overflow hidden
                    text-overflow ellipsis
                    white-space nowrap
                }
                .info-card-line-text p:last-child {
                    width 28%
                    overflow hidden
                    text-overflow ellipsis
                    white-space nowrap
                }
            }
            .infoList-card-line div:first-child {
                width 10px
                height 10px
                background-color #44A73D
                border-radius 50%
                margin 5px
            }
        }
    }
</style>